import Component from '@glimmer/component';

export default class RolesMultiAvatarPreviewIndexComponent extends Component {
  get roles() {
    if (this.args.roles?.promise) return this.args.roles.content;
    return this.args.roles;
  }

  get firstRole() {
    return this.roles[0];
  }

  get restRoles() {
    return this.roles.slice(1).map((role) => role.name);
  }
}
